import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import { faroInitializer } from "./app/config/faro.config";
import { environment } from 'src/environments/environment';

(window as any).googleMapsApiKey = environment.googleMapsApiKey;
if (environment.faro.enabled === true) {
 // faroInitializer()
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    const event = new Event('appReady');
    window.dispatchEvent(event);
  })
  .catch(err => console.error(err));
